angular.module('rjmNg.directives').directive "repeatChunk", [
  () ->
    transclude: 'element'
    compile: ($element, $attr) ->
      match = $attr.repeatChunk.match /^\s*([\S]+)\s+chunk-by\s+([\S]+)(.*)$/
      collectionString = match[1]
      chunkBy = match[2]
      match = match[3].match /^\s+tiebreak-by\s+([\S]+)\s*$/
      tiebreakBy = null
      if match
        tiebreakBy = match[1]
      _persistance =
        clone: null
        scope : null
      _comment = document.createComment ' end: ' + $attr.repeatChunk

      ($scope, $element, $attr, ctrl, $transclude) ->

        chunkBySize = (array, chunkSize) ->
          result = []
          currentChunk = []
          for item in array
            currentChunk.push item
            if currentChunk.length == chunkSize
              toAdd = {
                header: result.length
                items: currentChunk
              }
              result.push toAdd
              currentChunk = []
          if currentChunk.length > 0
            toAdd = {
              header: result.length
              items: currentChunk
            }
            result.push toAdd
          result

        chunkByField = (array, chunkField) ->
          result = []
          dict = {}
          for item in array
            if dict[item[chunkField]]?
              dict[item[chunkField]].items.push item
            else
              toAdd = {
                header: item[chunkField]
                items: [item]
              }
              dict[item[chunkField]] = toAdd
          for cf,item of dict
            result.push item
          result

        chunkByFieldWithTiebreak = (array, chunkField, tieField) ->
          result = []
          dict = {}
          for item in array
            if !dict[item[chunkField]]?
              dict[item[chunkField]] = {}
            if dict[item[chunkField]][item[tieField]]?
              dict[item[chunkField]][item[tieField]].items.push item
            else
              toAdd = {
                header: item[chunkField]
                tieheader: item[tieField]
                items: [item]
              }
              dict[item[chunkField]][item[tieField]] = toAdd
          for cf,vals of dict
            for tf,item of vals
              item.tie = true#vals.length > 1
              result.push item
          result

        $scope.$watchCollection collectionString, (collection) ->
          if not (collection instanceof Array) or not collection.length or not chunkBy
            return

          if not tiebreakBy and not isNaN(+chunkBy) and +chunkBy > 0 and +chunkBy % 1 is 0
            chunks = chunkBySize collection, +chunkBy
          else if not tiebreakBy and chunkBy.lastIndexOf('.',0) == 0
            chunks = chunkByField collection, chunkBy.slice(1)
          else if tiebreakBy.lastIndexOf('.',0) == 0 and chunkBy.lastIndexOf('.',0) == 0
            chunks = chunkByFieldWithTiebreak collection, chunkBy.slice(1), tiebreakBy.slice(1)

          $transclude (clone, scope) ->
            if _persistance.clone?
              _persistance.clone.remove()
            if _persistance.scope?
              _persistance.scope.$destroy()

            clone[clone.length++] = _comment
            scope['chunks'] = chunks
            $element.after clone
            _persistance.clone = clone
            _persistance.scope = scope
  ]

